import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { Router, ActivatedRoute } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { BOOK_STORE_TABS } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { MatDialog, MatSnackBar } from '@angular/material';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { IBook } from 'src/app/interfaces/book-store';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-books',
  templateUrl: './books.component.html',
  styleUrls: ['./books.component.scss']
})
export class BooksComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = BOOK_STORE_TABS.BOOKS;
  DISPLAY_STATUS_KEY: any;
  TITLE = "Book";
  COLLECTION: any = COLLECTION_NAME.BOOK_STORE_BOOKS;
  READING_LEVEL: any[] = [];
  LEVEL_KEY: any = null;

  form: FormGroup;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public store: BookstoreStore,
    public ps: PrintService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private storage: FireStorageService,
    private fb: FormBuilder,
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      search: [null, Validators.required]
    })
    this.READING_LEVEL = await this.store.fetchListArray(COLLECTION_NAME.READING_LEVEL, "name");
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT['submitted'];
    this.route.queryParams.subscribe(params => {
      const { level } = params;
      this.LEVEL_KEY = level || null;
      this.store.fetchBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, true, this.LEVEL_KEY)
    })
  }

  onCancel(){
    this.form.patchValue({search:null})
    this.store.fetchBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, true, this.LEVEL_KEY)
  }

  _onSearch(f: any) {
    const { search } = f;
    this.store.fetchBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, true, this.LEVEL_KEY, search || null)
  }


  onSelectedLevel(item?: any) {
    this.router.navigate([`/book-store/books/submitted`], { queryParams: { level: item.key } });
  }
  resolveBook(){
console.log('function comment')
    this.store.ResolveBookData()

  }

  ngDestroy() {
    const { fetchBookDataRef, scrollBookDataRef } = this.store;
    fetchBookDataRef && fetchBookDataRef.unsubscribe();
    scrollBookDataRef && scrollBookDataRef.unsubscribe();
  }

  onScroll() {
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    this.store.scrollBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, true, this.LEVEL_KEY)
  }

  create(item?: any) {
    this.router.navigate([`/book-store/library/${1}/${item ? item.key : 'draft'}`], { queryParams: { level: this.LEVEL_KEY } })
  }

  edit(item: any) {
    this.router.navigate([`/book-store/library/${1}/${item.key}`], { queryParams: { level: this.LEVEL_KEY } })
  }

  exercise(item: any) {
    this.router.navigate([`/book-store/books/data/1/${item.key}/exercise`], { queryParams: { level: this.LEVEL_KEY } })
  }

  delete(item: IBook) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: {
        title: `Delete ${this.TITLE}`,
        memo: `${this.TITLE} will permanently drop from app.`,
        name: item.name,
        button: "OK",
      },
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      disableClose: true,
      role: 'dialog'
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === 'yes') {
        if (item.bookFileDetail) {
          await this.storage.storageRef(item.bookFileDetail.filename).delete().toPromise();
        }
        if (item.audioBookFileDetail) {
          await this.storage.storageRef(item.audioBookFileDetail.filename).delete().toPromise();
        }
        if (item.coverFileDetail) {
          await this.storage.storageRef(item.coverFileDetail.filename).delete().toPromise();
        }
        this.store.deleteItem(this.COLLECTION, item, (success, error) => {
          if (success) {
            this.snackBar.open(`${this.TITLE} has been deleted.`, 'done', { duration: 2000 });
          }
          else {
            this.snackBar.open(error, 'Error')
          }
        })
      }
    });
  }
}
